import { styled } from '@uhg-abyss/web/tools/styled';
import { Box } from '@uhg-abyss/web/ui/Box';
import { Button } from '@uhg-abyss/web/ui/Button';

export const StyledVisionCareBox = styled(Box, {
  borderRadius: '8px',
});

export const StyledVisionCareButton = styled(Button, {
  '&.abyss-button-root': {
    marginTop: '$md',
  },
});
